import { Text } from "@gravity-ui/uikit";
import { AnimatePresence, motion } from "framer-motion";
import { appConfig } from "src/config";
import {
  telegramCardAnimation,
  titleAnimation,
} from "src/widgets/WelcomeModal/constants";

import css from "../SliderCard.module.scss";

export const SlideTelegram = ({ activeIndex }: { activeIndex: number }) => {
  return (
    <>
      <AnimatePresence initial={true} mode="wait">
        <motion.div {...titleAnimation} key={"title.slide." + activeIndex}>
          <Text variant="subheader-2">Новости</Text>
        </motion.div>
      </AnimatePresence>

      <motion.div
        className={css.slideTelegramContainer}
        {...telegramCardAnimation}
        key={"block.slide." + activeIndex}
      >
        <div className={css.slideTelegramContent}>
          <div className={css.slideTelegramCardContainer}>
            <img
              src={`${import.meta.env.BASE_URL}logo.png`}
              width={48}
              height={48}
              style={{ borderRadius: "100%" }}
            />
            <Text variant="subheader-2">
              {appConfig.displayName} | цены и парсинг
            </Text>
          </div>
          <Text variant="caption-2" color="secondary">
            999 подписчиков
          </Text>
        </div>
      </motion.div>
    </>
  );
};
